export const IMAGE_MAX_SIZE_MB = 20

export const MAX_INLINE_SIZE = IMAGE_MAX_SIZE_MB * 1024 * 1024

export const INLINE_IMAGE_SINGLE_FILE_COUNT = 1

export const ACCEPTED_IMAGE_TYPES = {
  'image/jpeg': ['.jpeg'],
  'image/jpg': ['.jpg'],
  'image/png': ['.png'],
}
